module.exports = __webpack_public_path__ + "static/media/view.730ec4bf.png";